module.exports = __webpack_public_path__ + "img/fi-rr-angle-small-down.eb6ecfa0.svg";